import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row space-x-4" }
const _hoisted_2 = ["name", "id", "required", "value"]


import LabelBase from "@/components/Texts/LabelBase.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputColor',
  props: {
    name: {},
    label: {},
    id: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const emitInput = (val) => {
  emit("update:modelValue", val);
};

return (_ctx: any,_cache: any) => {
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      name: props.name,
      id: props.id,
      required: props.is_required,
      value: props.modelValue,
      type: "color"
    }, null, 8, _hoisted_2), [
      [_directive_debounce, emitInput, "100"]
    ]),
    _createVNode(LabelBase, {
      text: props.label
    }, null, 8, ["text"])
  ]))
}
}

})